import React from 'react';
import { SectionId } from '../types';
import { FadeIn } from './ui/FadeIn';

export const Contact: React.FC = () => {
  return (
    <section id={SectionId.CONTACT} className="py-24 md:py-32 bg-stone-100 relative overflow-hidden">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-stone-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-stone-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10">
        <FadeIn className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-serif text-stone-800 mb-6">Begin Your Journey</h2>
          <p className="text-stone-500 font-light max-w-xl mx-auto">
            We take on a limited number of weddings each year to ensure the highest quality of attention and artistry. Let's create something beautiful together.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="bg-white p-8 md:p-12 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.05)]">
            <form className="space-y-8" onSubmit={(e) => e.preventDefault()}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="group">
                        <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2 group-focus-within:text-stone-800 transition-colors">Name</label>
                        <input type="text" className="w-full border-b border-stone-200 py-2 text-stone-800 focus:outline-none focus:border-stone-800 transition-colors bg-transparent placeholder-stone-300 font-serif text-lg" placeholder="Jane & John" />
                    </div>
                    <div className="group">
                        <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2 group-focus-within:text-stone-800 transition-colors">Email</label>
                        <input type="email" className="w-full border-b border-stone-200 py-2 text-stone-800 focus:outline-none focus:border-stone-800 transition-colors bg-transparent placeholder-stone-300 font-serif text-lg" placeholder="hello@example.com" />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="group">
                        <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2 group-focus-within:text-stone-800 transition-colors">Date</label>
                        <input type="text" className="w-full border-b border-stone-200 py-2 text-stone-800 focus:outline-none focus:border-stone-800 transition-colors bg-transparent placeholder-stone-300 font-serif text-lg" placeholder="DD / MM / YYYY" />
                    </div>
                    <div className="group">
                        <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2 group-focus-within:text-stone-800 transition-colors">Location</label>
                        <input type="text" className="w-full border-b border-stone-200 py-2 text-stone-800 focus:outline-none focus:border-stone-800 transition-colors bg-transparent placeholder-stone-300 font-serif text-lg" placeholder="City, Country" />
                    </div>
                </div>

                <div className="group">
                    <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2 group-focus-within:text-stone-800 transition-colors">Tell us your story</label>
                    <textarea rows={4} className="w-full border-b border-stone-200 py-2 text-stone-800 focus:outline-none focus:border-stone-800 transition-colors bg-transparent placeholder-stone-300 font-light resize-none" placeholder="We love details..."></textarea>
                </div>

                <div className="pt-8 text-center">
                    <button className="bg-stone-900 text-stone-50 px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-stone-700 transition-colors duration-300 w-full md:w-auto">
                        Request Availability
                    </button>
                </div>
            </form>
        </FadeIn>
      </div>
    </section>
  );
};